$(function () {

	$(document).on('input', 'input[subtype]', function (event) {
		const subtype	= $(this).attr('subtype');

		if (subtype == 'int') {
			this.value = this.value.replace(/[^0-9-]/g, '').replace(/(?!^)-/g, '');
		} else if (subtype == 'uint') {
			this.value = this.value.replace(/[^0-9]/g, '');
		} else if (subtype == 'float') {
			let commaMatch = 0;
			this.value = this.value.replace(/[^0-9-,]/g, '').replace(/(?!^)-/g, '').replace(/,/g, char => !commaMatch++ ? char : '');
		} else if (subtype == 'ufloat') {
			let commaMatch = 0;
			this.value = this.value.replace(/[^0-9,]/g, '').replace(/,/g, char => !commaMatch++ ? char : '');
		} else if (subtype == 'noWhitespace') {
			this.value = this.value.replace(/\s/g, '');
		} else if (subtype == 'databasecolumn') {
			this.value = this.value.replace(/[^A-Za-z0-9_]/g, '').replace(/^[0-9]/g, '');
		} else if (subtype == 'pattern-format') {
			let commaMatch = 0;
			this.value = this.value
				.replace(/[^0-9,#]/g, '') // Only allow 0-9 , and #
				.replace(/^,/g, '') // Remove , when at the beginning
				.replace(/,/g, char => !commaMatch++ ? char : ''); // remove multiple commas
		}
	});

});
